import { render, staticRenderFns } from "./addTagModal.vue?vue&type=template&id=d431c3d6&scoped=true&"
import script from "./addTagModal.vue?vue&type=script&lang=js&"
export * from "./addTagModal.vue?vue&type=script&lang=js&"
import style0 from "./addTagModal.vue?vue&type=style&index=0&id=d431c3d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d431c3d6",
  null
  
)

export default component.exports